export default __webpack_public_path__ + "static/assets/med_capsule_H_solid_01_f_mask.d9d609b4.png";